import { render, staticRenderFns } from "./PostReviewModal.vue?vue&type=template&id=28ac3044&"
import script from "./PostReviewModal.vue?vue&type=script&lang=ts&"
export * from "./PostReviewModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports